import { SxStyle } from '../../types/style';

const contentContainer: SxStyle = {
    padding: 2,
    minHeight: 'calc(100vh - 55px)'
};

const contentContainerGrid1: SxStyle = {
    justifyContent: 'center',
    alignItems: 'center',
    mb: 2
}

const contentContainerGrid1Item1Typography: SxStyle = {
    fontWeight: 700
}

const contentContainerGrid1Item2: SxStyle = {
    justifyContent: 'center',
    alignItems: 'center'
}

const contentContainerGrid2ItemPaper: SxStyle = {
    height: '700px',
    alignItems: 'center'
}

// Card
const card1: SxStyle = {
    backgroundColor: '#F4F4F4'
}

const card1CardContentTypography: SxStyle = {
    mb: '16px'
}

const card1CardContentTypography2: SxStyle = {
    fontWeight: 700
}

const card2: SxStyle = {
    width: '100%',
    height: '100%'
}

const card2CardContent: SxStyle = {
    paddingBottom: 0
}

const card2CardContentTypography: SxStyle = {
    mb: 2
}

const card2CardContentBox: SxStyle = {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '200px',
    minHeight: '200px',
    paddingRight: '10px',
}

const card2CardMedia: SxStyle = {
    width: '118px', 
    height: '72px', 
    borderRadius: '8px'
}

const card2CardContentBoxGridItemBox: SxStyle = {
    width: '100%'
}

const card2CardContentBoxGridItemBoxBox: SxStyle = {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
}

const card3CardContentGridItem1Box: SxStyle = {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
}

const card3CardContentGridItem1BoxButton: SxStyle = {
    fontWeight: "bold"
}

const card3CardContentGridItem2Stack: SxStyle = {
    alignItems: 'center',
    justifyContent: 'space-between'
}

const card4: SxStyle = {
    height: '425px'
}

const card4Search: SxStyle = {
    height: '425px'
}

const card4CardContentLink: SxStyle = {
    color: 'black',
    cursor: 'pointer'
}

const card4CardMedia: SxStyle = {
    borderRadius: '8px',
    marginBottom: 0.35
}

const card4CardContentTypography1: SxStyle = {
    fontWeight: 600
}

const card4CardContentTypography2: SxStyle = {
    marginBottom: 1.5,
    height: '40px'
}

const card4CardContentBox1: SxStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
}

const card4CardContentBox2AvatarGroupAvatar: SxStyle = {
    width: 36,
    height: 36,
    justifyContent: 'flex-end'
}

const card4CardContentBox2: SxStyle = {
    minHeight: '105px'
}

// Search Result
const contentContainerTabContextGridItem1Typography: SxStyle = {
    fontWeight: '700'
}

const contentContainerTabContextGridItem2Paper: SxStyle = {
    width: 'fit-content',
    display: 'flex',
    border: (theme) => `1px solid ${theme.palette.divider}`,
    flexWrap: 'wrap',
}

const contentContainerTabContextGridItem3TabPanel: SxStyle = {
    padding: 0
}

const contentContainerTabContextGridItem3TabPanelPaper: SxStyle = {
    padding: '16px'
}

const contentContainerTabContextGridItem3TabPanelPaperGridItemBox: SxStyle = {
    display: 'flex',
    justifyContent: 'flex-end'
}

export const homeStyle = {
    contentContainer,
    contentContainerGrid1,
    contentContainerGrid1Item1Typography,
    contentContainerGrid1Item2,
    contentContainerGrid2ItemPaper,
    card1,
    card1CardContentTypography,
    card1CardContentTypography2,
    card2,
    card2CardContent,
    card2CardContentTypography,
    card2CardContentBox,
    card2CardMedia,
    card2CardContentBoxGridItemBox,
    card2CardContentBoxGridItemBoxBox,
    card3CardContentGridItem1Box,
    card3CardContentGridItem1BoxButton,
    card3CardContentGridItem2Stack,
    card4,
    card4Search,
    card4CardContentLink,
    card4CardMedia,
    card4CardContentTypography1,
    card4CardContentTypography2,
    card4CardContentBox1,
    card4CardContentBox2AvatarGroupAvatar,
    card4CardContentBox2,
    contentContainerTabContextGridItem1Typography,
    contentContainerTabContextGridItem2Paper,
    contentContainerTabContextGridItem3TabPanel,
    contentContainerTabContextGridItem3TabPanelPaper,
    contentContainerTabContextGridItem3TabPanelPaperGridItemBox
}